import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";
import { ShieldCheck, Lock } from "lucide-react";

export const Route = createFileRoute("/de/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Datenschutzrichtlinie — Picamini.online" },
      {
        name: "description",
        content: "Datenschutzrichtlinie von Picamini.online. Alle Verarbeitungen erfolgen 100% lokal in Ihrem Browser (Client-Side).",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/de/datenschutzrichtlinie" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/privacy-policy" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/politica-de-privacidad" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/datenschutzrichtlinie" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/privacy-policy" },
    ],
  }),
  component: DePrivacyPolicyPage,
});

function DePrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="de" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-emerald-500 font-bold text-sm">
            <Lock className="size-4" /> Schutz personenbezogener Daten
          </div>
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">Datenschutzrichtlinie</h1>
          <p className="text-sm text-muted-foreground">Zuletzt aktualisiert: September 2026</p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-6 text-sm text-muted-foreground leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">1. Lokale Verarbeitung (Client-Side)</h2>
            <p>
              Picamini.online verarbeitet Ihre Daten (wie Namenslisten, Glücksrad-Einstellungen und hochgeladene PDF-Dateien) ausschließlich lokal im Arbeitsspeicher Ihres Endgeräts. Es findet keine Übertragung auf externe Server statt.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">2. Erhebung personenbezogener Daten</h2>
            <p>
              Wir verlangen keine Registrierung, keine Erstellung eines Nutzerkontos und keine Angabe einer E-Mail-Adresse, um unsere kostenlosen Online-Werkzeuge zu nutzen.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">3. Lokaler Speicher (LocalStorage)</h2>
            <p>
              Einige Werkzeuge speichern temporäre Einstellungen (z. B. Ihre Namenslisten) im Browser-Speicher (LocalStorage) Ihres eigenen Geräts, damit Sie diese beim nächsten Aufruf nicht erneut eingeben müssen. Sie können diesen Speicher jederzeit in Ihren Browsereinstellungen löschen.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">4. Analytics & Cookies</h2>
            <p>
              Wir nutzen minimale, datenschutzfreundliche Web-Analytics zur Messung aggregierter Besucherzahlen, ohne individuelle Nutzerprofile zu erstellen.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">5. Kontakt bei Datenschutzfragen</h2>
            <p>
              Bei Fragen zu unserer Datenschutzrichtlinie erreichen Sie uns per E-Mail unter <a href="mailto:support@eduzuma.com" className="text-primary font-bold hover:underline">support@eduzuma.com</a>.
            </p>
          </section>
        </div>
      </main>

      <SiteFooter lang="de" />
    </div>
  );
}
